import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";


@Injectable()
export class PortainerService {
  private uri = 'http://portainer.mymedax.lan';
  private endpointId = 2;
  private typeComposeStack = 2;
  private authHeaders = {"X-API-Key": "ptr_1BiM8aszn1ftHmYiUmhi7ms9LOAoZ9TNydaniim1PSo="};

  public constructor(
    private http: HttpClient
  ) {
  }

  public async createStack(name: string, content: string): Promise<void> {
    const url = `${this.uri}/api/stacks?endpointId=${this.endpointId}&method=string&type=${this.typeComposeStack}`;
    const body = {
      Name: name,
      StackFileContent: content,
      Env: []
    };

    return new Promise<void>((resolve, reject) => {
      this.http.post(url, body, {headers: this.authHeaders})
        .subscribe(
          () => resolve(),
          error => reject(error));
    });
  }
}
